import { object, string, number } from "yup";

export const bloodSugarSchema = object({
    sugarLevel: number()
        .typeError("Blood sugar level must be a number")
        .min(0, "Blood sugar level must be greater than or equal to 0")
        .max(300, "Blood sugar level must be less than or equal to 300")
        .required("Blood Sugar is required"),
    readingMethod: string().required("Reading method is required")
});